(() => {
  const REVIEW_IMAGE_ALT_TEXT = 'Customer review image';
  const REVIEW_IMAGE_SELECTOR = 'div.jdgm-media-card img';
  const REVIEW_WRAPPER_SELECTOR = '.jdgm-cards-wrapper';
  const MAX_WRAPPER_LOOKUPS = 20;
  const WRAPPER_LOOKUP_DELAY_MS = 500;

  /**
   * @param {Element | Document} [root]
   */
  const applyReviewImageAltText = (root = document) => {
    if (!(root instanceof Element || root instanceof Document)) return;

    for (const image of root.querySelectorAll(REVIEW_IMAGE_SELECTOR)) {
      image.setAttribute('alt', REVIEW_IMAGE_ALT_TEXT);
    }
  };

  const initializeReviewImageAltText = (attempt = 0) => {
    applyReviewImageAltText();

    const reviewWrapper = document.querySelector(REVIEW_WRAPPER_SELECTOR);
    if (!(reviewWrapper instanceof Element)) {
      if (attempt >= MAX_WRAPPER_LOOKUPS) return;

      window.setTimeout(() => {
        initializeReviewImageAltText(attempt + 1);
      }, WRAPPER_LOOKUP_DELAY_MS);
      return;
    }

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;

          if (node.matches('div.jdgm-media-card')) {
            applyReviewImageAltText(node);
            continue;
          }

          applyReviewImageAltText(node);
        }
      }
    });

    observer.observe(reviewWrapper, {
      childList: true,
      subtree: true,
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initializeReviewImageAltText();
    });
    return;
  }

  initializeReviewImageAltText();
})();
